<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the DSW21 specific component for rendering the Duty activity start line (first line in a block)    -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <v-row dense class="DutyActivityStart_Dsw21">
    <v-col cols="2">{{ time(dutyActivity.fromMinutesAfterMidnight) }}</v-col>
    <v-col cols="10"
      >{{ dutyStopsById[dutyActivity.startStopIdFk].longname }} &nbsp;<span class="dsw21-note">{{ dutyActivity.note }}</span></v-col
    >
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import TimeLinePoint from '../../../../components/decorators/TimeLinePoint.vue';

export default {
  name: 'DutyActivityStart_Dsw21',
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
